export const environment = {
  production: false,
  baseUrl: 'https://flight.akshartours.us:4013',
  b2b_url: 'https://flight.akshartours.us:4019',
  b2c_url: 'https://flight.akshartours.us:4017',
      airline_url: 'https://flight.akshartours.us',
      magicApiKey:'cm8yhnygd0002l403g1acp7sl',
      googleMapApi: 'AIzaSyB3N3Rg1vCjF6FmEc9qisxtS2JOpVUTKDM',
};
 